import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu } from "lucide-react"; // Icon for open/close sidebar
import adminLogo from "./AdminImage/logo-light-icon.png";
import config from "../../function/config";
import axios from "axios";
import { toast } from "react-toastify";
import admin from "./AdminImage/user3jpeg.jpeg";
import { motion } from "framer-motion";
 
export default function AddShip() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [openDropdown, setOpenDropdown] = useState(1);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1200); // Check screen size

  const [loading, setLoading] = useState(false);
  const [Title, setTitle] = useState("");
  const [vesselType, setvesselType] = useState("");
  const [ShortDescription, setShortDescription] = useState("");
  const [Flag, setFlag] = useState("");
  const [YearBuilt, setYearBuilt] = useState("");
  const [Capacity, setCapacity] = useState("");
  const [LOA, setLOA] = useState("");
  const [Class, setClass] = useState("");
  const [GRTNRT, setGRTNRT] = useState("");
  const [Teu, setTeu] = useState("");
  const [HiddenDetails, setHiddenDetails] = useState("");
  const [MainEngine, setMainEngine] = useState("");
  const [DWT, setDWT] = useState("");

  const [Email, setEmail] = useState("");
  const [MobileNO, setMobileNO] = useState("");
  const [BriefDescription, setBriefDescription] = useState("");
  const [images, setImages] = useState([]);
  const [Image, setImage] = useState("");
  const [ThumbnailImage, setThumbnailImage] = useState("");
  const [count, setCount] = useState(0);
  const [Price, setPrice] = useState("");

  const [allShipsReg, setallShipsReg] = useState([]);
const [newShip, setNewShip] = useState(
  JSON.parse(localStorage.getItem("newShip")) || false
);
const [prevShipCount, setPrevShipCount] = useState(
  JSON.parse(localStorage.getItem("prevShipCount")) || 0
);


 const token = localStorage.getItem("token");

useEffect(() => {
  async function fetchData() {
    try {
      const res1 = await axios.get(
        `${config.base_url}/api/HappyMarineShipping/viewShipForSale`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res1.data.status === 200) {
        const fetchedShips = res1.data.data.reverse();
        const currentShipCount = fetchedShips.length;

        // Check if a new ship was added AFTER the last seen count
        if (currentShipCount > prevShipCount) {
          setNewShip(true);
          localStorage.setItem("newShip", JSON.stringify(true));
          localStorage.setItem("prevShipCount", JSON.stringify(currentShipCount));
        }

        setallShipsReg(fetchedShips);
      }
    } catch (error) {
      console.log(error);
    }
  }

  fetchData();

  // Polling every 5 seconds
  const interval = setInterval(fetchData, 5000);

  return () => clearInterval(interval);
}, [prevShipCount]); // Only depend on prevShipCount to avoid unnecessary updates

const handleView = () => {
  setNewShip(false);
  localStorage.setItem("newShip", JSON.stringify(false));
  setPrevShipCount(allShipsReg.length);
  localStorage.setItem("prevShipCount", JSON.stringify(allShipsReg.length));
};
  
  const navigate = useNavigate();

 const [selectedImages, setSelectedImages] = useState([]); // Array of { file, preview }
 
 const handleImageChange = (e) => {
   const files = Array.from(e.target.files);
   const newImages = files.slice(0, 3 - images.length).map((file) => ({
     file,
     preview: URL.createObjectURL(file),
   }));
 
   setImages((prevImages) => [...prevImages, ...newImages]);
 };
 
 const removeImage = (index) => {
   const updated = [...images];
   updated.splice(index, 1);
   setImages(updated);
 };
  const toggleDropdown = (id) => {
    if (openDropdown === id) {
      setOpenDropdown(null); // Close if clicking the same dropdown
    } else {
      setOpenDropdown(id); // Open the clicked dropdown
    }
  };

  const [allCategory, setallCategory] = useState([]);
  const [allSubCategory, setallSubCategory] = useState([]);

  const[SubType,setSubType] = useState('')

  const vesselSubTypes = {
  Barge: [" Cargo Barge","Tanker Barge", "Accommodation Barge", "Self-Propelled Barge"],
  Bulk: ["Handymax Bulk Carrier","Supramax Bulk Carrier","Ultramax Bulk Carrier","Panamax Bulk Carrier","Kamsarmax Bulk Carrier", "Mini Bulk Carrier","Post-Panamax Bulk Carrier", "Log Carrier", "Cement Carrier"],
  Cargo: ["General Cargo"],
  Container: ["Feeder Container Ship","Panamax Container Ship","Post-Panamax Container Ship","New Panamax (Neo-Panamax)","Mega Container carrier","Fully Cellular Container Ship","Container Barge"],
  Fishing: ["Longliner", "Purse Seiner","Shrimp Trawler","Stern Trawler"],
  Multipurpose: ["General Cargo + Container Ship","General Cargo + Bulk Carrier","Container + Ro-Ro Ship (ConRo)","Heavy Lift Multipurpose Vessel","Tweendecker (with multiple cargo decks)",'Livestock'],
  "Passenger/Ferry":["Cruise Ship","High-Speed Craft", "Catamaran Ferry", "Hydrofoil", "Hovercraft", "Day Passenger Vessel", "Water Taxi"],
  Reefer: ["Conventional Reefer Ship","Reefer Container Ship","Side Door Reefer Ship","Palletized Reefer Ship","Fish Reefer Vessel"],
  RoRo:["Pure Car Carrier (PCC)", "Ro-Ro Cargo Ship","Ro-Pax Ship (Ro-Ro + Passenger)","LOLO Cargo Ship","Double-Ended Ro-Ro"],
  Tanker: ["Crude Oil Tanker","Product Tanker","Chemical Tanker","LNG Carrier (Liquefied Natural Gas)","LPG Carrier (Liquefied Petroleum Gas)","Bitumen Tanker","Oil Recovery Vessel","Bunker vessel ","Slop Barge Tanker","Water Tanker", "Edible Oil Tanker"],
  Dredger: ["Cutter Suction Dredger","Hopper Dredger","Bucket Dredger","Backhoe Dredger","Grab Dredger"],
  "Floating Crane": ["Sheerleg Crane Vessel","Crane Barge","Jack-Up Crane Vessel","Derrick Barge","Floating Gantry Crane"],
  "Floating Dock": ["Pontoon-Type Floating Dock","Submersible Floating Dock","Ship-Lift Floating Dock","Floating Dry Dock"],
  "Landing Craft": ["Landing Craft Utility (LCU)","Landing Craft tanker"],
  Yacht:["Sailing Yacht","Motor Yacht","Catamaran Yacht","Trimaran Yacht","Superyacht","Megayacht","Flybridge Yacht"],
  "Tug Boat":["Harbor Tug","Ocean Tug","Escort Tug","Azimuth Stern Drive (ASD) Tug","Pusher Tug","Anchor Handling Tug (AHT)"],
  "Supply Boat":["Platform Supply Vessel (PSV)","Anchor Handling Tug Supply (AHTS)","Utility Vessel","Multi-Purpose Support Vessel (MPSV)","Diving Support Vessel (DSV)","Cable Laying Vessel","Accommodation Supply Vessel","DP Supply Boat (Dynamic Positioning)"],
  "Crew Boat": [" Fast Crew Boat","Fast Supply Intervention Vessel (FSIV)"],
  Other: [""]
};
  

  // fetch Category  data

  const [MainCategory, setMainCategory] = useState("Ship For Sale"); // Track selected main category
  const [filteredSubCategories, setFilteredSubCategories] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const res1 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewSubCategory`,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (res1.data.status === 200) {
          console.log(res1);
          setallSubCategory(res1.data.data);
        }

        const res2 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewCategory`,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (res2.data.status === 200) {
          console.log(res2);
          setallCategory(res2.data.data);
        }
      } catch (error) {
        console.error("Error fetching data", error);
      }
    }
    fetchData();
  }, [config.base_url, count]);

  const [amenities, setAmenities] = useState([]);
  const [formDataA, setFormDataA] = useState({});

  // Fetch amenities from the backend
  // fetch ship data
  useEffect(() => {
    async function fetchdata() {
      try {
        const res1 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewAmenities`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
           
          }
        );
        if (res1.data.status === 200) {
          console.log(res1);
          setAmenities(res1.data.data);
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url, count]);

  const handleChange = (e, amenity) => {
    const { name, value } = e.target;
    setFormDataA((prevData) => ({
      ...prevData,
      [name]: value,  // This updates the specific amenity input in formData
    }));
  };

  // Filter subcategories when main category changes
  // useEffect(() => {
  //   if (selectedCategory) {
  //     const filtered = allSubCategory.filter(
  //       (sub) => Number(sub.category) === Number(selectedCategory) // Convert both to numbers
  //     );
  //     setFilteredSubCategories(filtered);
  //   } else {
  //     setFilteredSubCategories([]);
  //   }
  // }, [selectedCategory, allSubCategory]);

  const [generatedCode, setGeneratedCode] = useState("");
const [codeCounter, setCodeCounter] = useState("");


  const normalize = (str) => str.toLowerCase().replace(/[^a-z]/g, "");


const subCategoryPrefixes = {
  barge: "BRG",
  bulk: "BLK",
  cargo: "CRG",
  container: "CNT",
  fishing: "FIS",
  multipurpose: "MPP",
  passengerferry: "PAX",
  reefer: "REF",
  roro: "ROR",
  tanker: "TNK",
  tugboat: "TUG",
  dredger: "DRG",
  floatingcrane: "FLC",
  landingcraft: "LCT",
  yacht: "YCT",
  supplyboat: "SUB",
  crewboat: "CRB",
  floatingdock: "FLD",
  other: "OTR"
};

useEffect(() => { 
  if (vesselType) {
    const normalized = normalize(vesselType);
    const prefix = subCategoryPrefixes[normalized];
    if (prefix) {
      setGeneratedCode(prefix); // ✅ Only set the prefix
    } else {
      setGeneratedCode("");
    }
  }
}, [vesselType]);



  

  const handleSubmitSale = async (e, id) => {
    e.preventDefault();
  
    
  
    // if (!isAdmin && userShipsCount >= maxLimit) {
    //   toast.error(
    //     `Your ${userPlan} plan allows only ${maxLimit} ships. Please upgrade your plan to add more.`
    //   );
    //   setShowPaymentPopup(true);
    //   return;
    // }
  
    setLoading(true);
    const formData = new FormData();
  
    // Append text fields
    formData.append("title", Title);
    formData.append("vessel_type", vesselType);
    formData.append("sub_type", SubType);
    formData.append("short_description", ShortDescription);
    formData.append("flag", Flag);
    formData.append("year_built", YearBuilt);
    formData.append("capacity", Capacity);
    formData.append("LOA", LOA);
    formData.append("Class", Class);
    formData.append("GRT_NRT", GRTNRT);
    formData.append("Teu", Teu);
    formData.append("main_engine", MainEngine);
    formData.append("DWT", DWT);
    formData.append("Price", Price);
    formData.append("email", Email);
    formData.append("phone", MobileNO);
    formData.append("brief_description", BriefDescription);
    formData.append("ship_code", generatedCode);
  
    // Append multiple images
    if (images.length > 0) {
      images.forEach((imgObj) => {
        formData.append("image", imgObj.file); // ✅ file is the File object
      });
    }
  
    try {
      console.log("Generated Ship Code:", generatedCode);
  
      const response = await axios.post(
        `${config.base_url}/api/HappyMarineShipping/AddShipForSale`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Token ${token}`,
          },
        }
      );
  
      if (response.data.status === 200) {
        navigate("/regShip");
        console.log(response);
        setLoading(false);
        toast.success("Ship Registered Successfully!", {
          autoClose: 1500,
          position: "top-right",
        });
        setCount(id);
  
        // Reset form fields
        setvesselType("");
        setShortDescription("");
        setFlag("");
        setCapacity("");
        setClass("");
        setDWT("");
        setEmail("");
        setImage("");
        setMobileNO("");
        setMainEngine("");
        setGRTNRT("");
        setLOA("");
        setPrice("");
        setYearBuilt("");
        setTeu("");
        setBriefDescription("");
      } else {
        setLoading(false);
        console.log("error1");
        toast.error("Fill the required Fields", {
          autoClose: 1500,
          position: "top-right",
        });
      }
    } catch (err) {
      setLoading(false);
      console.log("error2", err);
      toast.error("Error", {
        autoClose: 2000,
        position: "top-right",
      });
    }
  };
  
  

  const [listening, setListening] = useState(false);
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = SpeechRecognition ? new SpeechRecognition() : null;
    if (recognition) {
      recognition.continuous = true; // Allow continuous listening
      recognition.interimResults = false; // Only get final results
    }
  
    const handleTranscript = (lower) => {
      // Vessel Type
      const vesselTypes = [
        "barge",
        "bulk",
        "cargo",
        "container",
        "fishing",
        "multipurpose",
        "passenger",
        "reefer",
        "roro",
        "tanker",
        "dredger",
        "floating crane",
        "landing craft",
        "Yacht",
        "tug boat",
        "supply boat",
        "crew boat",
        "other",
      ];
      vesselTypes.forEach((type) => {
        if (lower.includes(type)) setvesselType(capitalizeWords(type));
      });
  
      const flagMatch = lower.match(/flag (is )?([a-z\s]+)/);
      if (flagMatch) setFlag(capitalizeWords(flagMatch[2].trim()));
  
      const yearMatch = lower.match(/\b(19|20)\d{2}\b/);
      if (yearMatch) setYearBuilt(yearMatch[0]);
  
      const capMatch = lower.match(/capacity (is )?([\d,\.]+\s*\w*)/);
      if (capMatch) setCapacity(capMatch[2].trim());
  
      const loaMatch = lower.match(/l o a (is )?([\d,\.]+\s*\w*)/);
      if (loaMatch) setLOA(loaMatch[2].trim());
  
      const grtMatch = lower.match(
        /grt(?:\/nrt)?(?: is)?(?: of)? ([\d,\.]+\s*\w*)/
      );
      if (grtMatch) setGRTNRT(grtMatch[1].trim());
  
      const teuMatch =
        lower.match(/(?:t e u|hp).{0,10}?(\d+(\.\d+)?)/i) ||
        lower.match(/(\d+(\.\d+)?).{0,5}?(teu|hp)/i);
      if (teuMatch) setTeu(teuMatch[1]);
  
      let emailText = lower.replace(/ at /g, "@").replace(/ dot /g, ".");
      const emailMatch = emailText.match(
        /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,}/
      );
      if (emailMatch) setEmail(emailMatch[0]);
  
      // Replace spoken words like "plus" and "zero"
      let cleaned = lower
        .toLowerCase()
        .replace(/plus/g, "+")
        .replace(/zero/g, "0")
        .replace(/ at /g, "@")
        .replace(/ dot /g, ".")
        .replace(/[\s\-]/g, ""); // remove spaces and dashes
  
      const mobileMatch = cleaned.match(/(\+?\d{10,15})/);
      if (mobileMatch) {
        setMobileNO(mobileMatch[1]);
      }
  
      const classMatch = lower.match(/class (is )?([a-zA-Z0-9]+)/);
      if (classMatch) setClass(classMatch[2].toUpperCase());
  
      const engineMatch = lower.match(/main engine (is )?([a-zA-Z0-9\s\-]+)/);
      if (engineMatch) setMainEngine(capitalizeWords(engineMatch[2].trim()));
  
      const dwtMatch = lower.match(/dwt (is )?([\d,\.]+\s*\w*)/);
      if (dwtMatch) setDWT(dwtMatch[2].trim());
  
      const priceMatch = lower.match(/price (is )?([\d,\.]+\s*\w*)/);
      if (priceMatch) setPrice(priceMatch[2].trim());
  
      if (lower.includes("short description")) {
        const shortDesc = lower.split("short description")[1]?.trim();
        if (shortDesc) setShortDescription(capitalizeWords(shortDesc));
      }
  
      if (lower.includes("particular") || lower.includes("brief description")) {
        const brief =
          lower.split("particular").pop()?.trim() ||
          lower.split("brief description").pop()?.trim();
        if (brief) setBriefDescription(capitalizeWords(brief));
      }
    };
  
    const startListening = () => {
      if (!recognition) {
        alert("Speech Recognition is not supported in this browser");
        return;
      }
  
      setListening(true);
      recognition.start();
  
      recognition.onresult = (event) => {
        for (let i = event.resultIndex; i < event.results.length; ++i) {
          if (event.results[i].isFinal) {
            const transcript = event.results[i][0].transcript;
            console.log("Voice Input:", transcript);
            handleTranscript(transcript.toLowerCase());
          }
        }
      };
    };
  
    // Utility function to capitalize words
    const capitalizeWords = (text) =>
      text.replace(/\b\w/g, (char) => char.toUpperCase());
  

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1200);
      if (window.innerWidth <= 1200) {
        setIsSidebarOpen(false); // Hide sidebar by default on small screens
        setOpenDropdown(false);
      }
    };

    handleResize(); // Call on mount
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Toggle dropdown
  const toggleDropdownprofile = (e) => {
    e.stopPropagation(); // Prevent click event from bubbling
    setIsOpen((prev) => !prev);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const [hasNotification, setHasNotification] = useState(true);
  const [isOpennoti, setIsOpennoti] = useState(false);
  const toggleDropdownNotification = (e) => {
    e.stopPropagation();
    setIsOpennoti((prev) => !prev);

    // Remove notification dot when opening dropdown
    if (hasNotification) {
      setHasNotification(false);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpennoti(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  



  return (
    <div className="h-screen flex flex-col bg-gray-100">
      {/* Navbar - Full Width, Above Sidebar */}
      <nav className="bg-[#123d5f] p-4 flex items-center shadow-md w-full transition-all duration-300">
        {/* Left Side - Admin Logo & Title */}
        <div className="flex items-center gap-2">
          <img src={adminLogo} className="w-[35px] h-[35px]" alt="Admin Logo" />
          {isSidebarOpen && (
            <h1 className="text-lg font-bold text-white">Admin</h1>
          )}
        </div>

        {/* Menu Button (Moves on Sidebar Toggle) */}
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className={`absolute xm:hidden transition-all duration-300 text-white ${
            isSidebarOpen ? "left-60" : "left-16"
          }`}
        >
          <Menu size={28} />
        </button>
        {/* mobile screen menu button */}
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className={`absolute xm:block hidden transition-all duration-300 text-white ${
            isSidebarOpen ? "left-32" : "left-16"
          }`}
        >
          <Menu size={28} />
        </button>

        {/* Admin Profile  (Right Side) */}
        <div className="relative ml-auto pr-5 flex items-center gap-20">
         
          {/* Admin Image */}
          <div>
            <img
              src={admin} // Replace with {admin} if using a variable
              className="rounded-full w-[35px] cursor-pointer"
              alt="admin"
              onClick={toggleDropdownprofile}
            />
            {/* Dropdown */}
            {isOpen && (
              <motion.div
                ref={dropdownRef}
                initial={{ opacity: 0, rotateX: 90, scale: 0.9 }}
                animate={{ opacity: 1, rotateX: 0, scale: 1 }}
                exit={{ opacity: 0, rotateX: 90, scale: 0.9 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                className="absolute right-0 mt-2 bg-white shadow-lg rounded-md w-40 py-2 origin-top transform"
              >
                <ul className="text-gray-700">
                  <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                    <Link to={'/admin/profile'}>Profile</Link>
                  </li>
                  <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                  <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                  </li>
                </ul>
              </motion.div>
            )}
          </div>
        </div>
      </nav>

      {/* Sidebar & Content Wrapper */}
      <div className="flex flex-1 overflow-hidden">
         {/* Sidebar */}
               <div
                 className={`${
                   isSidebarOpen ? "w-60 overflow-y-auto" : "w-16"
                 }  bg-white xl:hidden text-[#8D97AD] shadow-xl transition-all duration-300  max-h-screen `}
               >
                 <ul className="mt-10 flex flex-col gap-3 ">
                   {/* Dashboard */}
                   <li className="px-4 py-2 text-lg   flex items-center">
                     <i className="fa-solid fa-gauge mr-3"></i>
                     {isSidebarOpen && <Link to="/login/dashboard">Dashboard</Link>}
                   </li>
       
                   {isSidebarOpen && <div className="px-5 mt-2 w-[75%]"><h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">Registrations</h1></div>}
       
                   {/* Ship For Sale Dropdown */}
                   <li className="px-2 text-[#00c292] border-l-4 border-[#00c292]  text-lg  flex flex-col  relative">
                     <div
                       className="flex items-center  justify-between cursor-pointer p-2"
                       onClick={() => toggleDropdown(1)} // Toggle Ship For Sale dropdown
                     >
                       <div className="flex items-center  gap-2 hover:text-[#00c292]">
                        <h1 className="text-xl text-center font-semibold">-</h1>
                         {isSidebarOpen && <span>Ship For Sale</span>}
                       </div>
                       {isSidebarOpen && (
                         <i
                           className={`fa-solid ${
                             openDropdown === 1 ? "fa-chevron-up" : "fa-chevron-right"
                           }`}
                         ></i>
                       )}
                     </div>
       
                     {!isSidebarOpen && openDropdown === 1 && (
                       <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                         <ul>
                           <li className="px-4 py-1 hover:text-[#00c292]">
                             <Link to="/admin/addShip">Add Ships</Link>
                           </li>
                           <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                             <Link to="/admin/viewShip">View Ships</Link>
                           </li>
                         </ul>
                       </div>
                     )}
       
                     {/* Dropdown Content */}
                     {isSidebarOpen && (
                       <div
                         className={`ml-6 mt-2 transition-all duration-300 ${
                           openDropdown === 1
                             ? "max-h-40 opacity-100"
                             : "max-h-0 opacity-0 overflow-hidden"
                         }`}
                       >
                         <ul>
                           <li className="px-4 py-1 hover:text-[#00c292]">
                             <Link to="/admin/addShip">Add Ships</Link>
                           </li>
                           <li className="px-4 text-[#8D97AD] py-1 hover:text-[#00c292]">
                             <Link to="/admin/viewShip">View Ships</Link>
                           </li>
                         </ul>
                       </div>
                     )}
                   </li>
       
                   <li className="px-2  text-lg flex flex-col relative">
                     <div
                       className="flex items-center justify-between cursor-pointer p-2"
                       onClick={() => toggleDropdown(2)} // Toggle Category dropdown
                     >
                       <div className="flex items-center hover:text-[#00c292] gap-2">
                         <h1 className="text-xl text-center font-semibold">-</h1>
                         {isSidebarOpen && <span>Ship For Charter</span>}
                       </div>
                       {isSidebarOpen && (
                         <i
                           className={`fa-solid ${
                             openDropdown === 2 ? "fa-chevron-up" : "fa-chevron-right"
                           }`}
                         ></i>
                       )}
                     </div>
                     {!isSidebarOpen && openDropdown === 2 && (
                       <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                         <ul>
                           <li className="px-1 py-1 w-full hover:text-[#00c292]">
                             <Link to="/admin/addCharter">Add Charter</Link>
                           </li>
                           <li className="px-1 py-1 w-full hover:text-[#00c292]">
                             <Link to="/admin/shipforCharter">View Charter</Link>
                           </li>
                         </ul>
                       </div>
                     )}
       
                     {/* Dropdown Content */}
                     {isSidebarOpen && (
                       <div
                         className={`ml-6 mt-2 transition-all duration-300 ${
                           openDropdown === 2
                             ? "max-h-40 opacity-100"
                             : "max-h-0 opacity-0 overflow-hidden"
                         }`}
                       >
                         <ul>
                           <li className="px-4 py-1 hover:text-[#00c292]">
                             <Link to="/admin/addCharter">Add Charter</Link>
                           </li>
                           <li className="px-4 py-1 hover:text-[#00c292]">
                             <Link to="/admin/shipforCharter">View Charter</Link>
                           </li>
                         </ul>
                       </div>
                     )}
                   </li>
       
                    <li className="px-2  text-lg flex flex-col relative group ">
                     <div
                       className="flex items-center justify-between cursor-pointer p-2"
                       onClick={() => toggleDropdown(3)} // Toggle Sub Category dropdown
                     >
                       <div className="flex items-center hover:text-[#00c292] gap-2">
                          <h1 className="text-xl text-center font-semibold">-</h1>
                         {isSidebarOpen && <span>Open Cargo </span>}
                       </div>
                       {isSidebarOpen && (
                         <i
                           className={`fa-solid ${
                             openDropdown === 3 ? "fa-chevron-up" : "fa-chevron-right"
                           }`}
                         ></i>
                       )}
                     </div>
       
                     {!isSidebarOpen && openDropdown === 3 && (
                       <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                         <ul>
                           <li className="px-1 py-1 w-full hover:text-[#00c292]">
                             <Link to='/admin/addcargo'>Add Cargo</Link>
                           </li>
                           <li className="px-1 py-1 w-full hover:text-[#00c292]">
                              <Link to='/admin/viewCargo' >View Cargo</Link>
                           </li>
                         </ul>
                       </div>
                     )}
       
                     {/* Dropdown Content */}
                     {isSidebarOpen && (
                       <div
                         className={`ml-6 mt-2 transition-all duration-300 ${
                           openDropdown === 3
                             ? "max-h-40 opacity-100"
                             : "max-h-0 opacity-0 overflow-hidden"
                         }`}
                       >
                         <ul>
                           <li className="px-1 py-1 w-full hover:text-[#00c292]">
                             <Link to='/admin/addcargo'>Add Cargo</Link>
                           </li>
                           <li className="px-1 py-1 w-full hover:text-[#00c292]">
                              <Link to='/admin/viewCargo' >View Cargo</Link>
                           </li>
                         </ul>
                       </div>
                     )}
                   </li>
       
                   <li className="px-2  text-lg flex flex-col relative group ">
                     <div
                       className="flex items-center justify-between cursor-pointer p-2"
                       onClick={() => toggleDropdown(4)} // Toggle Sub Category dropdown
                     >
                       <div className="flex items-center hover:text-[#00c292] gap-2">
                          <h1 className="text-xl text-center font-semibold">-</h1>
                         {isSidebarOpen && <span>Supply Equipments </span>}
                       </div>
                       {isSidebarOpen && (
                         <i
                           className={`fa-solid ${
                             openDropdown === 4 ? "fa-chevron-up" : "fa-chevron-right"
                           }`}
                         ></i>
                       )}
                     </div>
       
                     {!isSidebarOpen && openDropdown === 4 && (
                       <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                         <ul>
                           <li className="px-1 py-1 w-full hover:text-[#00c292]">
                             <Link to="/admin/addsEq">Add Equipments</Link>
                           </li>
                           <li className="px-1 py-1 w-full hover:text-[#00c292]">
                             <Link to="/admin/shipforEq">View Equipments</Link>
                           </li>
                         </ul>
                       </div>
                     )}
       
                     {/* Dropdown Content */}
                     {isSidebarOpen && (
                       <div
                         className={`ml-6 mt-2 transition-all duration-300 ${
                           openDropdown === 4
                             ? "max-h-40 opacity-100"
                             : "max-h-0 opacity-0 overflow-hidden"
                         }`}
                       >
                         <ul>
                           <li className="px-1 py-1 w-full hover:text-[#00c292]">
                             <Link to="/admin/addsEq">Add Equipments</Link>
                           </li>
                           <li className="px-1 py-1 w-full hover:text-[#00c292]">
                             <Link to="/admin/shipforEq">View Equipments</Link>
                           </li>
                         </ul>
                       </div>
                     )}
                   </li>
       
                    
                    {isSidebarOpen && <div className="px-5 mt-2 w-[75%]"><h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">Approvals</h1></div>}
                                 {isSidebarOpen && <ul className="px-2  text-lg flex flex-col relative group">
                            <li className="px-1 py-2 hover:text-[#00c292] flex justify-between items-center">
                             <Link
                               to="/admin/shipforsale"
                               onClick={() => handleView()} // Ensure it runs before navigation
                             >
                              - Ships For Sale
                             </Link>
                             {newShip && (
                               <span className="ml-2 text-xs bg-red-500 text-white px-2 py-1 rounded-full">
                                 New
                               </span>
                             )}
                           </li>
                           
                            <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                             <Link
                               to="/admin/shipforCharterApp"
                               onClick={() => handleView()} // Ensure it runs before navigation
                             >
                              - Ship For Charter
                             </Link>
                             
                           </li>
                           
                            <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                             <Link
                               to='/admin/LogisticsAppr'
                               onClick={() => handleView()} // Ensure it runs before navigation
                             >
                              - Open Cargo
                             </Link>
                             
                           </li>
                           
                            <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                             <Link
                               to="/admin/shipforEqApp"
                               onClick={() => handleView()} // Ensure it runs before navigation
                             >
                              - Supply Equipments
                             </Link>
                           </li>
                           
                           
                         </ul>}
                   
                   
       
                   {/* Settings Dropdown */}
                   <li className="px-3 py-2 text-lg flex flex-col relative group">
                     <div
                       className="flex items-center justify-between cursor-pointer p-2 hover:text-[#00c292]"
                       onClick={() => toggleDropdown(6)}
                     >
                       <div className="flex items-center gap-2">
                         <i className="fa-solid fa-gear"></i>
                         {isSidebarOpen && <span>Settings</span>}
                       </div>
                       {isSidebarOpen && (
                         <i
                           className={`fa-solid ${
                             openDropdown === 6 ? "fa-chevron-up" : "fa-chevron-right"
                           }`}
                         ></i>
                       )}
                     </div>
       
                     {/* Hover Dropdown (Closed Sidebar) */}
                     {!isSidebarOpen && openDropdown === 6 && (
                       <div className="absolute left-full top-0 bg-white shadow-lg transition-all duration-300 w-40 py-2 rounded-lg z-20">
                         <ul>
                           <li className="px-4 py-2 hover:bg-gray-100">
                             <Link to="/admin/profile">Profile</Link>
                           </li>
                           <li className="px-4 py-2 hover:bg-gray-100">
                           <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                           </li>
                         </ul>
                       </div>
                     )}
       
                     {/* Click Dropdown (Open Sidebar) */}
                     {isSidebarOpen && (
                       <div
                         className={`ml-6 mt-2 transition-all duration-300 ${
                           openDropdown === 6
                             ? "max-h-40 opacity-100"
                             : "max-h-0 opacity-0 overflow-hidden"
                         }`}
                       >
                         <ul>
                           <li className="px-4 py-1 hover:text-[#00c292]">
                             <Link to="/admin/profile">Profile</Link>
                           </li>
                           <li className="px-3 py-1 hover:text-[#00c292]">
                            <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                           </li>
                         </ul>
                       </div>
                     )}
                   </li>
                 </ul>
               </div>
       
               {/* mobile screen sidebar */}
       
               <div
                 className={`fixed hidden xl:block h-full bg-white text-[#8D97AD] shadow-xl transition-all duration-300 ${
                   isMobile
                     ? isSidebarOpen
                       ? "w-full translate-x-0" // Open in full width on mobile
                       : "-translate-x-full w-0" // Hide sidebar on mobile
                     : isSidebarOpen
                     ? "w-60 translate-x-0" // Open normally on desktop
                     : "w-0" // Hide sidebar on desktop
                 }`}
               >
                 <ul className="mt-10 flex flex-col gap-3 ">
                   {/* Dashboard */}
                   <li className={`px-4 py-2 text-lg    flex items-center`}>
                     {isSidebarOpen && <i className="fa-solid fa-gauge mr-3"></i>}
                     {isSidebarOpen && <Link to="/login/dashboard">Dashboard</Link>}
                   </li>
                     {isSidebarOpen && <div className="px-5  w-[50%]"><h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">Registrations</h1></div>}
                   {/* Ship For Sale Dropdown */}
                   <li
                     className={`px-2  text-lg text-[#00c292] border-l-4 border-[#00c292] flex flex-col  relative`}
                   >
                     <div
                       className="flex items-center  justify-between cursor-pointer p-2"
                       onClick={() => toggleDropdown(1)} // Toggle Ship For Sale dropdown
                     >
                       <div className="flex items-center  gap-2 hover:text-[#00c292]">
                         {isSidebarOpen && <h1 className="text-xl text-center font-semibold">-</h1>}
                         {isSidebarOpen && <span>Ship For Sale</span>}
                       </div>
                       {isSidebarOpen && (
                         <i
                           className={`fa-solid ${
                             openDropdown === 1 ? "fa-chevron-up" : "fa-chevron-right"
                           }`}
                         ></i>
                       )}
                     </div>
       
                     {!isSidebarOpen && openDropdown === 1 && (
                       <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                         <ul>
                           <li className="px-4 py-1 hover:text-[#00c292]">
                             <Link to="/admin/addShip">Add Ships</Link>
                           </li>
                           <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                             <Link to="/admin/viewShip">View Ships</Link>
                           </li>
                         </ul>
                       </div>
                     )}
       
                     {/* Dropdown Content */}
                     {isSidebarOpen && (
                       <div
                         className={`ml-6 mt-2 transition-all duration-300 ${
                           openDropdown === 1
                             ? "max-h-40 opacity-100"
                             : "max-h-0 opacity-0 overflow-hidden"
                         }`}
                       >
                         <ul>
                           <li className="px-4 py-1 hover:text-[#00c292]">
                             <Link to="/admin/addShip">Add Ships</Link>
                           </li>
                           <li className="px-4 text-[#8D97AD] py-1 hover:text-[#00c292]">
                             <Link to="/admin/viewShip">View Ships</Link>
                           </li>
                         </ul>
                       </div>
                     )}
                   </li>
       
                   <li className="px-3  text-lg flex flex-col relative">
                     <div
                       className="flex items-center justify-between cursor-pointer p-2"
                       onClick={() => toggleDropdown(2)} // Toggle Category dropdown
                     >
                       <div className="flex items-center hover:text-[#00c292] gap-2">
                         {isSidebarOpen &&  <h1 className="text-xl text-center font-semibold">-</h1>}
                         {isSidebarOpen && <span>Ship For Charter</span>}
                       </div>
                       {isSidebarOpen && (
                         <i
                           className={`fa-solid ${
                             openDropdown === 2 ? "fa-chevron-up" : "fa-chevron-right"
                           }`}
                         ></i>
                       )}
                     </div>
                     {!isSidebarOpen && openDropdown === 2 && (
                       <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                         <ul>
                           <li className="px-1 py-1 w-full hover:text-[#00c292]">
                             <Link to="/admin/addCharter">Add Charter</Link>
                           </li>
                           <li className="px-1 py-1 w-full hover:text-[#00c292]">
                             <Link to="/admin/shipforCharter">View Charter</Link>
                           </li>
                         </ul>
                       </div>
                     )}
       
                     {/* Dropdown Content */}
                     {isSidebarOpen && (
                       <div
                         className={`ml-6 mt-2 transition-all duration-300 ${
                           openDropdown === 2
                             ? "max-h-40 opacity-100"
                             : "max-h-0 opacity-0 overflow-hidden"
                         }`}
                       >
                         <ul>
                           <li className="px-4 py-1 hover:text-[#00c292]">
                             <Link to="/admin/addCharter">Add Charter</Link>
                           </li>
                           <li className="px-4 py-1 hover:text-[#00c292]">
                             <Link to="/admin/shipforCharter">View Charter</Link>
                           </li>
                         </ul>
                       </div>
                     )}
                   </li>
       
                    <li className="px-3 text-lg flex flex-col relative group ">
                     <div
                       className="flex items-center justify-between cursor-pointer p-2"
                       onClick={() => toggleDropdown(3)} // Toggle Sub Category dropdown
                     >
                       <div className="flex items-center hover:text-[#00c292] gap-2">
                         {isSidebarOpen &&  <h1 className="text-xl text-center font-semibold">-</h1>}
                         {isSidebarOpen && <span>Open Cargo</span>}
                       </div>
                       {isSidebarOpen && (
                         <i
                           className={`fa-solid ${
                             openDropdown === 3 ? "fa-chevron-up" : "fa-chevron-right"
                           }`}
                         ></i>
                       )}
                     </div>
       
                     {!isSidebarOpen && openDropdown === 3 && (
                       <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                         <ul>
                           <li className="px-1 py-1 w-full hover:text-[#00c292]">
                             <Link to='/admin/addcargo'>Add Cargo</Link>
                           </li>
                           <li className="px-1 py-1 w-full hover:text-[#00c292]">
                              <Link to='/admin/viewCargo' >View Cargo</Link>
                           </li>
                         </ul>
                       </div>
                     )}
       
                     {/* Dropdown Content */}
                     {isSidebarOpen && (
                       <div
                         className={`ml-6 mt-2 transition-all duration-300 ${
                           openDropdown === 3
                             ? "max-h-40 opacity-100"
                             : "max-h-0 opacity-0 overflow-hidden"
                         }`}
                       >
                         <ul>
                           <li className="px-1 py-1 w-full hover:text-[#00c292]">
                             <Link to='/admin/addcargo'>Add Cargo</Link>
                           </li>
                           <li className="px-1 py-1 w-full hover:text-[#00c292]">
                              <Link to='/admin/viewCargo' >View Cargo</Link>
                           </li>
                         </ul>
                       </div>
                     )}
                   </li>
       
                   <li className="px-3  text-lg flex flex-col relative group ">
                     <div
                       className="flex items-center justify-between cursor-pointer p-2"
                       onClick={() => toggleDropdown(4)} // Toggle Sub Category dropdown
                     >
                       <div className="flex items-center hover:text-[#00c292] gap-2">
                         {isSidebarOpen &&  <h1 className="text-xl text-center font-semibold">-</h1>}
                         {isSidebarOpen && <span>Supply Equipments</span>}
                       </div>
                       {isSidebarOpen && (
                         <i
                           className={`fa-solid ${
                             openDropdown === 4 ? "fa-chevron-up" : "fa-chevron-right"
                           }`}
                         ></i>
                       )}
                     </div>
       
                     {!isSidebarOpen && openDropdown === 4 && (
                       <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                         <ul>
                           <li className="px-1 py-1 w-full hover:text-[#00c292]">
                             <Link to="/admin/addsEq">Add Equipments</Link>
                           </li>
                           <li className="px-1 py-1 w-full hover:text-[#00c292]">
                             <Link to="/admin/shipforEq">View Equipments</Link>
                           </li>
                         </ul>
                       </div>
                     )}
       
                     {/* Dropdown Content */}
                     {isSidebarOpen && (
                       <div
                         className={`ml-6 mt-2 transition-all duration-300 ${
                           openDropdown === 4
                             ? "max-h-40 opacity-100"
                             : "max-h-0 opacity-0 overflow-hidden"
                         }`}
                       >
                         <ul>
                           <li className="px-1 py-1 w-full hover:text-[#00c292]">
                             <Link to="/admin/addsEq">Add Equipments</Link>
                           </li>
                           <li className="px-1 py-1 w-full hover:text-[#00c292]">
                             <Link to="/admin/shipforEq">View Equipments</Link>
                           </li>
                         </ul>
                       </div>
                     )}
                   </li>
       
                  <li className="px-3 text-lg flex flex-col relative group">
                    {/* Clickable Div */}
                   {isSidebarOpen && <div className="px-5  w-[50%]"><h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">Approvals</h1></div>}
                  
                                {isSidebarOpen && <ul className="px-2 py-2  text-lg flex gap-3
                                 flex-col relative group">
                           <li className="px-1 py-2 hover:text-[#00c292] flex justify-between items-center">
                            <Link
                              to="/admin/shipforsale"
                              onClick={() => handleView()} // Ensure it runs before navigation
                            >
                             - Ships For Sale
                            </Link>
                            {newShip && (
                              <span className="ml-2 text-xs bg-red-500 text-white px-2 py-1 rounded-full">
                                New
                              </span>
                            )}
                          </li>
                          
                           <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                            <Link
                              to="/admin/shipforCharterApp"
                              onClick={() => handleView()} // Ensure it runs before navigation
                            >
                             - Ship For Charter
                            </Link>
                            
                          </li>
                          
                           <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                            <Link
                              to='/admin/LogisticsAppr'
                              onClick={() => handleView()} // Ensure it runs before navigation
                            >
                             - Open Cargo
                            </Link>
                            
                          </li>
                          
                           <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                            <Link
                              to="/admin/shipforEqApp"
                              onClick={() => handleView()} // Ensure it runs before navigation
                            >
                             - Supply Equipments
                            </Link>
                          </li>
                          
                          
                        </ul>
                    }
                  
                    {/* Click Dropdown (For open sidebar) */}
                    {isSidebarOpen && (
                      <div
                        className={`ml-6 mt-2 transition-all duration-300 ${
                          openDropdown === 5
                            ? "max-h-48 opacity-100 "
                            : "max-h-0 opacity-0 overflow-hidden"
                        }`}
                      >
                       <ul>
                           <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
                            <Link
                              to="/admin/shipforsale"
                              onClick={() => handleView()} // Ensure it runs before navigation
                            >
                             - Ships For Sale
                            </Link>
                            {newShip && (
                              <span className="ml-2 text-xs bg-red-500 text-white px-2 py-1 rounded-full">
                                New
                              </span>
                            )}
                          </li>
                          
                           <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
                            <Link
                              to="/admin/shipforCharterApp"
                              onClick={() => handleView()} // Ensure it runs before navigation
                            >
                             - Ship For Charter
                            </Link>
                            
                          </li>
                          
                           <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
                            <Link
                              to='/admin/LogisticsAppr'
                              onClick={() => handleView()} // Ensure it runs before navigation
                            >
                             - Open Cargo
                            </Link>
                            
                          </li>
                          
                           <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
                            <Link
                              to="/admin/shipforEqApp"
                              onClick={() => handleView()} // Ensure it runs before navigation
                            >
                             - Supply Equipments
                            </Link>
                          </li>
                          
                          
                        </ul>
                      </div>
                    )}
                  </li>
       
       
                   {/* Settings Dropdown */}
                   <li className="px-3  text-lg flex flex-col relative group">
                     <div
                       className="flex items-center justify-between cursor-pointer p-2 hover:text-[#00c292]"
                       onClick={() => toggleDropdown(6)}
                     >
                       <div className="flex items-center gap-2">
                         {isSidebarOpen && <i className="fa-solid fa-gear"></i>}
                         {isSidebarOpen && <span>Settings</span>}
                       </div>
                       {isSidebarOpen && (
                         <i
                           className={`fa-solid ${
                             openDropdown === 6 ? "fa-chevron-up" : "fa-chevron-right"
                           }`}
                         ></i>
                       )}
                     </div>
       
                     {/* Hover Dropdown (Closed Sidebar) */}
                     {!isSidebarOpen && openDropdown === 6 && (
                       <div className="absolute left-full top-0 bg-white shadow-lg transition-all duration-300 w-40 py-2 rounded-lg z-20">
                         <ul>
                           <li className="px-4 py-2 hover:bg-gray-100">
                             <Link to="/admin/profile">Profile</Link>
                           </li>
                           <li className="px-3 py-1 hover:text-[#00c292]">
                            <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                           </li>
                         </ul>
                       </div>
                     )}
       
                     {/* Click Dropdown (Open Sidebar) */}
                     {isSidebarOpen && (
                       <div
                         className={`ml-6 mt-2 transition-all duration-300 ${
                           openDropdown === 6
                             ? "max-h-40 opacity-100"
                             : "max-h-0 opacity-0 overflow-hidden"
                         }`}
                       >
                         <ul>
                           <li className="px-4 py-1 hover:text-[#00c292]">
                             <Link to="/admin/profile">Profile</Link>
                           </li>
                           <li className="px-3 py-1 hover:text-[#00c292]">
                            <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                           </li>
                         </ul>
                       </div>
                     )}
                   </li>
                 </ul>
               </div>
       

        {/* Main Content */}
        <div className="flex-1 py-4 overflow-y-auto">
          <div className="bg-white  shadow-sm text-xl w-full p-5">
            <div className="flex justify-between items-center">
              <h1>Add Ship</h1>
              <div className="flex text-sm gap-2">
                <Link to={'/adminHome'}>Home</Link> <span>/</span>
                <p className="text-[#00c292]">Add Ship</p>
              </div>
            </div>
          </div>

          <div className="w-full py-5 px-4">
            <form className="bg-white mt-2 rounded w-full  mx-auto">
  <div className="p-5">
    <h1 className="text-black font-bold text-xl">Register Ship For Sale</h1>
  </div>
  <hr className="text-gray-200 w-full" />

  {/* Mic Button */}
 {/* <div className="absolute xm:right-16  right-56  z-10">
                <button
                  type="button"
                  onClick={() => {
                    if (listening) {
                      recognition.stop(); // Stop if currently listening
                      setListening(false);
                    } else {
                      startListening(); // Start if not listening
                    }
                  }}
                  className={`px-4 py-2 rounded-full shadow-lg transition-all ${
                    listening ? "bg-red-100 animate-pulse" : "bg-gray-100"
                  }`}
                >
                  {listening ? (
                    <i className="fa-solid fa-stop text-red-600 text-xl"></i> // Stop icon
                  ) : (
                    <i className="fa-solid fa-microphone text-xl"></i> // Mic icon
                  )}
                </button>
              </div> */}

  <div className="p-5 mt-5 space-y-6">
    {/* Vessel Type */}
    <div className="flex items-center gap-3">
      <label htmlFor="VesselType" className="font-semibold w-40">
        Vessel Type
      </label>
      <select
        value={vesselType}
        onChange={(e) => setvesselType(e.target.value)}
        className="flex-1 rounded border border-gray-400 p-2 text-[#d1a460]"
        id="VesselType"
      >
        <option hidden value="">
          - Select -
        </option>
        <option disabled value="">
          Categories
        </option>
        <option value="Barge">Barge</option>
        <option value="Bulk">Bulk</option>
        <option value="Cargo">Cargo</option>
        <option value="Container">Container</option>
        <option value="Fishing">Fishing</option>
        <option value="Multipurpose">Multipurpose</option>
        <option value="Passenger/Ferry">Passenger/Ferry</option>
        <option value="Reefer">Reefer</option>
        <option value="RoRo">RoRo</option>
        <option value="Tanker">Tanker</option>
        <option value="Dredger">Dredger</option>
        <option value="Floating Crane">Floating Crane</option>
        <option value="Floating Dock">Floating Dock</option>
        <option value="Landing Craft">Landing Craft</option>
        <option value="Yacht">Yacht</option>
        <option value="Tug Boat">Tug Boat</option>
        <option value="Supply Boat">Supply Boat</option>
        <option value="Crew Boat">Crew Boat</option>
        <option value="Other">Other</option>
      </select>
    </div>

    {vesselType && vesselSubTypes[vesselType] && (
      <div className="flex items-center gap-3">
        <label htmlFor="SubType" className="font-semibold w-40">
          Vessel Sub-Type
        </label>
        <select
          value={SubType}
          onChange={(e) => setSubType(e.target.value)}
          className="flex-1 rounded border border-gray-400 p-2 text-[#d1a460]"
          id="SubType"
        >
          <option hidden value="">
            - Select Sub-Type -
          </option>
          {vesselSubTypes[vesselType].map((sub, idx) => (
            <option key={idx} value={sub.trim()}>
              {sub.trim()}
            </option>
          ))}
        </select>
      </div>
    )}

    {generatedCode && (
      <div className="flex items-center gap-3">
        <label htmlFor="GeneratedCode" className="font-semibold w-40">
          Reference Id
        </label>
        <input
          value={generatedCode}
          onChange={(e) => setGeneratedCode(e.target.value)}
          className="flex-1 rounded border border-gray-400 p-2 text-gray-500"
          id="GeneratedCode"
          disabled
        />
      </div>
    )}

    {/* Short Description */}
    <div className="flex items-start gap-3">
      <label htmlFor="shortDescription" className="font-semibold w-40 mt-2">
        Short Description
      </label>
      <textarea
        placeholder="Enter Ship Name/Type/Yr Built/Country/DWT"
        value={ShortDescription}
        onChange={(e) => setShortDescription(e.target.value)}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="shortDescription"
      ></textarea>
    </div>

    {/* Flag */}
    <div className="flex items-center gap-3">
      <label htmlFor="Flag" className="font-semibold w-40">
        Flag
      </label>
      <input
        placeholder="Enter the Country Name"
        value={Flag}
        onChange={(e) => setFlag(e.target.value)}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="Flag"
      />
    </div>

    {/* Year Built */}
    <div className="flex items-center gap-3">
      <label htmlFor="YearBuilt" className="font-semibold w-40">
        Year Built
      </label>
      <input
        placeholder="Enter the Year"
        value={YearBuilt}
        onChange={(e) => setYearBuilt(e.target.value)}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="YearBuilt"
      />
    </div>

    {/* LOA */}
    <div className="flex items-center gap-3">
      <label htmlFor="LOA" className="font-semibold w-40">
        Length of all: LOA(m)
      </label>
      <input
        value={LOA}
        onChange={(e) => setLOA(e.target.value)}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="LOA"
        placeholder="Enter LOA"
      />
    </div>

    {/* Class */}
    <div className="flex items-center gap-3">
      <label htmlFor="Class" className="font-semibold w-40">
        Class
      </label>
      <input
        value={Class}
        onChange={(e) => setClass(e.target.value)}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="Class"
        placeholder="Enter the Class"
      />
    </div>

    {/* GRT/NRT */}
    <div className="flex items-center gap-3">
      <label htmlFor="GRTNRT" className="font-semibold w-40">
        GRT/NRT
      </label>
      <input
        value={GRTNRT}
        onChange={(e) => setGRTNRT(e.target.value)}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="GRTNRT"
        placeholder="Enter GRT/NRT"
      />
    </div>

    {/* TEU/HP */}
    <div className="flex items-center gap-3">
      <label htmlFor="Teu" className="font-semibold w-40">
        TEU/HP
      </label>
      <input
        value={Teu}
        onChange={(e) => setTeu(e.target.value)}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="Teu"
        placeholder="Enter TEU/HP"
      />
    </div>

    {/* Main Engine */}
    <div className="flex items-center gap-3">
      <label htmlFor="MainEngine" className="font-semibold w-40">
        Main Engine
      </label>
      <input
        value={MainEngine}
        onChange={(e) => setMainEngine(e.target.value)}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="MainEngine"
        placeholder="Enter Main Engine"
      />
    </div>

    {/* DWT */}
    <div className="flex items-center gap-3">
      <label htmlFor="DWT" className="font-semibold w-40">
        DWT
      </label>
      <input
        value={DWT}
        onChange={(e) => setDWT(e.target.value)}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="DWT"
        placeholder="Enter DWT"
      />
    </div>

    {/* Price */}
    <div className="flex items-center gap-3">
      <label htmlFor="Price" className="font-semibold w-40">
        Price (USD)
      </label>
      <input
        value={Price}
        onChange={(e) => setPrice(e.target.value)}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="Price"
        placeholder="Enter the Price"
      />
    </div>

    {/* Email */}
    <div className="flex items-center gap-3">
      <label htmlFor="Email" className="font-semibold w-40">
        Email
      </label>
      <input
        value={Email}
        onChange={(e) => setEmail(e.target.value)}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="Email"
        placeholder="Enter your Email"
      />
    </div>

    {/* Mobile No */}
    <div className="flex items-center gap-3">
      <label htmlFor="MobileNO" className="font-semibold w-40">
        Mobile No
      </label>
      <input
        value={MobileNO}
        onChange={(e) => setMobileNO(e.target.value)}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="MobileNO"
        placeholder="Enter Your Mobile No"
      />
    </div>

    {/* Brief Description */}
    <div className="flex items-start gap-3">
      <label htmlFor="BriefDescription" className="font-semibold w-40 mt-2">
        Ship Particular
      </label>
      <textarea
        value={BriefDescription}
        onChange={(e) => setBriefDescription(e.target.value)}
        rows={5}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="BriefDescription"
        placeholder="Write about your ship in brief..."
      ></textarea>
    </div>

    {/* Upload Images */}
    <div>
      {images.length > 0 && (
        <div className="flex gap-4 mb-4 flex-wrap">
          {images.map((img, index) => (
            <div key={index} className="relative w-28 h-28">
              <img
                src={img.preview}
                alt={`preview ${index}`}
                className="w-full h-full rounded border border-gray-300"
              />
              <button
                onClick={() => removeImage(index)}
                className="absolute top-0 right-0 bg-red-500 text-white text-xs px-1 rounded-bl"
              >
                ✕
              </button>
            </div>
          ))}
        </div>
      )}

      <label htmlFor="image">Upload Images (Max 3 Images)</label>
      <input
        type="file"
        onChange={handleImageChange}
        multiple
        accept="image/*"
        className="w-full mt-2 rounded border border-gray-400 text-gray-500 p-2"
        id="image"
        disabled={selectedImages.length >= 3}
      />
    </div>
  </div>

  {/* Submit */}
  <hr className="text-gray-300 w-full" />
  <div className="p-4">
    <button
      onClick={(e) => handleSubmitSale(e)}
      type="submit"
      className="bg-green-600 hover:bg-green-500 text-white px-5 py-2 rounded w-full"
    >
      {loading ? (
        <span className="block w-[16px] h-[16px] border-2 border-b-0 border-white rounded-full m-auto animate-spin"></span>
      ) : (
        "Submit"
      )}
    </button>
  </div>
</form>
          </div>
        </div>
      </div>
    </div>
  );
}
